import cx from 'classnames';
import {isInOneStepCreateFlow} from '~/common/utils/event_utils';
import './EditBox.sass';

export const EditBox = ({children, className = ''}) => (
  <div
    className={cx('edit_box', className, {
      'edit_box__one-step': isInOneStepCreateFlow,
    })}
  >
    {children}
  </div>
);
